import React from "react";
import Link from "next/link";
import {
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  Typography,
} from "@mui/material";

interface SidebarPopperProps {
  handleSubmenuSelect: (index: number,name: string) => void;
  submenuSelected: number | null;
  submenu: {id: number; key:string; name: string; submenuPath: string }[];
  menuTitle: string;
  menuIcon: string;
  pathPrefix: string;
  menuColor: string;
  menuId: string
}

const SidebarPopper: React.FC<SidebarPopperProps> = ({
  handleSubmenuSelect,
  submenuSelected,
  submenu,
  menuTitle,
  menuIcon,
  pathPrefix,
  menuColor,
  menuId
}) => {
  return (
    <List sx={{ boxShadow: "10px 10px 20px 0px #0000001A", padding:"0px",}}>
      <ListItem
        sx={{
          width: "100%",
          height: '3.25rem',
          display: "flex",
          alignItems: "center",
          background: "white",
          position: "relative",
        }}
        className="dark:bg-TJ-Earl-Grey"
      >
        <Typography
          className="text-TJ-Almost-Black dark:text-TJ-white"
          sx={{
            fontFamily: "Cerebri Sans",
            fontSize: "0.875rem",
            fontWeight: 600,
            lineHeight: "1.25rem",
            textAlign: "left",
          }}
        >
          {menuTitle}
        </Typography>
      </ListItem>
      {submenu.map((subMenuItem, subMenuItemIndex) => {
        const path =
          subMenuItem.submenuPath && subMenuItem.submenuPath !== "/" && subMenuItem.submenuPath !== ""
            ? subMenuItem.submenuPath === pathPrefix 
              ? pathPrefix  // Special case: if submenuPath equals pathPrefix, use just pathPrefix
              : pathPrefix + subMenuItem.submenuPath
            : subMenuItem.submenuPath === ""
              ? pathPrefix  // Special case: if submenuPath is empty, use just pathPrefix
              : `/submenu-fallback?name=${encodeURIComponent(subMenuItem.name)}&menuTitle=${encodeURIComponent(menuTitle)}&menuIcon=${encodeURIComponent(menuIcon)}`;

        return (
          <Link href={path} passHref key={`popper-submenu-` + subMenuItem.id}>
            <ListItem
              disablePadding
              sx={{
                paddingLeft: "16px",
                height: 44,
                display: "flex", // Add this line
                alignItems: "center", // Add this line
                position: "relative",
                overflow: "hidden",
              }}
              onClick={() => handleSubmenuSelect(Number(subMenuItem.id),subMenuItem.name)}
            >
              <ListItemButton
                sx={{
                  paddingLeft: 0,
                  borderLeft: "1px solid #A0A0A0",
                  borderLeftColor: "#A0A0A0",
                }}
              >
                <ListItemText sx={{ padding: 0, display: "flex", alignItems: "center" }}> {/* Add display and alignItems */}
                  <Typography
                    className="text-TJ-Almost-Black dark:text-TJ-white"
                    sx={{
                      fontFamily: "Cerebri Sans",
                      fontWeight: 400,
                      fontSize: "0.875rem",
                      paddingLeft: "27px",
                      borderLeft: "2px solid",
                      ...(submenuSelected === Number(subMenuItem.id)
                        ? {
                            borderLeftColor: menuColor,
                            color: menuColor,
                          }
                        : {
                            borderLeftColor: "transparent",
                          }),
                    }}
                  >
                    {subMenuItem.name}
                  </Typography>
                </ListItemText>
              </ListItemButton>
            </ListItem>
          </Link>
        );
      })}
    </List>
  );
};

export default SidebarPopper;
